import { gsap } from 'gsap';

const CUBIC = /^cubic\(\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*\)$/;

export const CUSTOM_EASE = 'custom';
export const DEFAULT_CURVE = [0.42, 0, 0.58, 1];

const bezier = (t, a, b, c, d) => {
    const u = 1 - t;
    return (u * u * u * a) + (3 * u * u * t * b) + (3 * u * t * t * c) + (t * t * t * d);
};

export const isCubicEase = (ease) => CUBIC.test(String(ease || ''));

export const parseCubicEase = (ease) => {
    const match = CUBIC.exec(String(ease || ''));
    if (!match) return null;
    return match.slice(1, 5).map(Number);
};

export const formatCubicEase = (x1, y1, x2, y2) => {
    const round = (value) => Math.round(value * 1000) / 1000;
    return `cubic(${round(x1)},${round(y1)},${round(x2)},${round(y2)})`;
};

export const sampleCubic = (progress, x1, y1, x2, y2) => {
    if (progress <= 0) return 0;
    if (progress >= 1) return 1;

    let low = 0;
    let high = 1;
    let t = progress;
    for (let step = 0; step < 14; step += 1) {
        const x = bezier(t, 0, x1, x2, 1);
        if (Math.abs(x - progress) < 0.0001) break;
        if (x < progress) low = t;
        else high = t;
        t = (low + high) / 2;
    }

    return bezier(t, 0, y1, y2, 1);
};

export const easeFunction = (name) => {
    const curve = parseCubicEase(name);
    if (curve) {
        return (progress) => sampleCubic(progress, curve[0], curve[1], curve[2], curve[3]);
    }

    try {
        return gsap.parseEase(name || 'none');
    } catch (error) {
        return (progress) => progress;
    }
};
